import React from 'react';

import { Form } from 'antd';
import PropTypes from 'prop-types';

import { FormInput } from '@src/components/atoms/form/form-input';
import { Heading15 } from '@src/theme';
import { bemClassName } from '@src/utils/bem';

import { StyledSearchForm } from './styles';

const b = bemClassName('search-form');

const SearchForm = ({ onSearch }) => {
  const [form] = Form.useForm();

  const handleSearch = (values) => {
    onSearch?.(values.searchTerm);
  };

  return (
    <StyledSearchForm>
      <div className={b()}>
        <div className={b('title')}>
          <Heading15>Search</Heading15>
        </div>
        <Form form={form} layout="vertical" onFinish={handleSearch}>
          <FormInput
            name="searchTerm"
            label="Search posts..."
            placeholder="Enter keywords, tags, or topics"
            form={form}
          />
        </Form>
      </div>
    </StyledSearchForm>
  );
};

SearchForm.propTypes = {
  onSearch: PropTypes.func,
};

export default React.memo(SearchForm);
